import { Grid, Typography } from '@mui/material';
import { CheckboxItem } from 'lib/designSystem/CheckBoxItem';
import React from 'react';

import {
  PaymentRequestPassiveCheckboxesSetters,
  PaymentRequestPassiveCheckboxesState,
} from '../hooks/usePaymentRequestPassiveCheckboxes';

interface PaymentRequestPassiveCheckboxesProps {
  checkboxes: PaymentRequestPassiveCheckboxesState;
  setters: PaymentRequestPassiveCheckboxesSetters;
  canShowPayouts?: boolean;
}

export const PaymentRequestPassiveCheckboxes: React.FC<
  PaymentRequestPassiveCheckboxesProps
> = ({ checkboxes, setters, canShowPayouts = false }) => {
  const {
    showPendingAccounts,
    showAppliedDocuments,
    showPayouts,
    showClientInfo,
    showDates,
    showAmounts,
    showObservation,
  } = checkboxes;

  const {
    setShowPendingAccounts,
    setShowAppliedDocuments,
    setShowPayouts,
    setShowClientInfo,
    setShowDates,
    setShowAmounts,
    setShowObservation,
  } = setters;

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
        >
          Información General
        </Typography>
        <CheckboxItem
          label="Mostrar información del cliente"
          checked={showClientInfo}
          onChange={setShowClientInfo}
        />
        <CheckboxItem
          label="Mostrar montos"
          checked={showAmounts}
          onChange={setShowAmounts}
        />
        <CheckboxItem
          label="Mostrar fechas"
          checked={showDates}
          onChange={setShowDates}
        />
      </Grid>
      <Grid item xs={6}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
        >
          Detalles de la Solicitud
        </Typography>
        <CheckboxItem
          label="Mostrar cuentas pendientes"
          checked={showPendingAccounts}
          onChange={setShowPendingAccounts}
        />
        <CheckboxItem
          label="Mostrar documentos aplicados"
          checked={showAppliedDocuments}
          onChange={setShowAppliedDocuments}
        />
        {canShowPayouts && (
          <CheckboxItem
            label="Incluir pagos realizados"
            checked={showPayouts}
            onChange={setShowPayouts}
          />
        )}
        <CheckboxItem
          label="Incluir observación"
          checked={showObservation}
          onChange={setShowObservation}
        />
      </Grid>
    </Grid>
  );
};
